import clsx from "clsx";
import React, {FunctionComponent} from "react";
import RadioButton, {RadioButtonProps} from "./RadioButton";
import FlexContent, {FlexContentAlignment, FlexContentDirection} from "../flex-content/FlexContent";

type RadioButtonsProps = Pick<RadioButtonProps, "value" | "onChange" | "disabled"> & {
    id: string;
    options: Omit<RadioButtonProps, "checked" | "onChange" | "disabled">[];
    stacked?: boolean;
};

const RadioButtons: FunctionComponent<RadioButtonsProps> = ({id, value, options, onChange, disabled, stacked}) => {
    return (
        <FlexContent
            direction={stacked ? FlexContentDirection.COLUMN : FlexContentDirection.ROW}
            alignment={stacked ? FlexContentAlignment.INITIAL : FlexContentAlignment.CENTER}
            allowWrap
            cssClass="radio-buttons"
        >
            {options.map((option) =>
                <RadioButton
                    key={clsx(option.label, option.value)}
                    id={clsx(id, option.label, option.value).replaceAll(" ", "-")}
                    checked={option.value === value}
                    onChange={onChange}
                    disabled={disabled}
                    {...option}
                />
            )}
        </FlexContent>
    );
};

export default RadioButtons;
